export default __webpack_public_path__ + "static/media/1 BHK B - 909.85.a17501b6.png";